/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_File_Tree_UpdatedInputs */

const es_components_file_tree_updated = /** @type {(inputs: Components_File_Tree_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualizado`)
};

const en_components_file_tree_updated = /** @type {(inputs: Components_File_Tree_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Updated`)
};

/**
* | output |
* | --- |
* | "Updated" |
*
* @param {Components_File_Tree_UpdatedInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_file_tree_updated = /** @type {((inputs?: Components_File_Tree_UpdatedInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_File_Tree_UpdatedInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_file_tree_updated(inputs)
	return en_components_file_tree_updated(inputs)
});
export { components_file_tree_updated as "components.file_tree.updated" }